// extracted by mini-css-extract-plugin
module.exports = {"text":"OnDemandCardContent_text__E7q1V","title":"OnDemandCardContent_title__q5isa","description":"OnDemandCardContent_description__hV5DR"};